import React, {createContext, useState} from 'react';
import {Button, Grid, Menu} from "semantic-ui-react";
import {useHistory, useParams} from "react-router";
import {Basic} from './Basic'
import {Sections} from './Sections'
import {Topics} from "./Topics";

export const Context = createContext({})

export const Details = () => {
    const params = useParams();
    const history = useHistory();

    const [section_id, setSectionId] = useState(0);

    return (
        <React.Fragment>
            <a href={"#"} onClick={history.goBack}>Voltar para lista</a>
            <Context.Provider value={{course_id: params.id, section_id, setSectionId}}>
                <Basic/>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={7} style={{paddingLeft: 0}}>
                            <Sections/>
                        </Grid.Column>
                        <Grid.Column width={9} style={{paddingLeft: 0}}>
                            <Topics/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Context.Provider>
        </React.Fragment>
    );
}